import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    DELETED_REASON,
    POST_IS_DELETED_FIND_WHY__IN_CODEX,
    POST_IS_DELETED_FIND_WHY__READ,
} from 'mk/autogenerated/translations/DeletedPostAlert.298ed2e324f44cc7ca7599ea912055e7'
import { aboutRulesCodexUrl } from 'mk2/apps/about/urls';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { Link } from 'mk2/components/Link';
import { postDeletedByToText, DeletedByRole } from 'mk2/helpers/deleteable';
import { timeAt } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './DeletedPostAlert.mscss';

interface OwnProps {
    heading?: React.ReactNode;
    deletedByRole: DeletedByRole;
    deletedAt?: string;
    deletedBy?: string;
    reason?: string;
}

export const DeletedPostAlert: React.FunctionComponent<OwnProps> = React.memo(({
    heading,
    deletedByRole,
    deletedAt,
    deletedBy,
    reason,
}) => (
    <div className={styles.DeletedPostAlert}>
        <div className={styles.DeletedPostAlert__icon}>
            <FontAwesomeIcon icon={faTrash} />
        </div>
        <div className={styles.DeletedPostAlert__heading}>
            {heading || postDeletedByToText(deletedByRole)}
            {deletedBy && (
                <span>
                    &nbsp;(
                    <Link
                        className={styles.DeletedPostAlert__deletedBy}
                        to={url(blogsProfileUrl, { username: deletedBy })}
                    >
                        {deletedBy}
                    </Link>
                    )
                </span>
            )}
        </div>
        {deletedByRole === DeletedByRole.DeletedByAdmin && (
            <div className={styles.DeletedPostAlert__codex}>
                <span>
                    <Link to={aboutRulesCodexUrl}>{POST_IS_DELETED_FIND_WHY__READ}</Link>
                    {POST_IS_DELETED_FIND_WHY__IN_CODEX}
                </span>
            </div>
        )}
        {reason && (
            <div className={styles.DeletedPostAlert__reason}>
                <strong>{DELETED_REASON}</strong>: {reason}
            </div>
        )}
        {deletedAt && <div className={styles.DeletedPostAlert__deletedAt}>{timeAt(deletedAt)}</div>}
    </div>
));

DeletedPostAlert.displayName = 'DeletedPostAlert';
